<template>
  <div>
    <div v-if="autenticando" class="modal">
      <img
        src="../../assets/imagens/loadingSpinner.gif"
        alt="Roda de carregamento girando"
      />
      <label>Aguarde. Autenticando.</label>
    </div>

    <ModalEscolhaPermissao
      v-if="exibirModalEscolha"
      :perfil-atual="perfilAtual"
      @perfil-escolhido="aoEscolherPerfil"
    />
  </div>
</template>

<script>
import Auth from "../../services/Auth";
import ModalEscolhaPermissao from "../../components/ModalEscolhaPermissao";
import { rotaInicial } from "../../router/helpers";
import metaDados from "../../helpers/metaDados";

export default {
  name: "Autenticar",
  components: { ModalEscolhaPermissao },
  metaInfo() {
    return {
      title: "Sistema de Avaliação de Servidores",
      titleTemplate: "%s - Casa Civil do Estado de Goiás",
      meta: [
        {
          vmid: "description",
          name: "description",
          property: "description",
          content:
            "Página de acesso e cadastro de cessões/disposições de servidores.",
        },
        {
          vmid: "og:description",
          property: "og:description",
          content:
            "Página de acesso e cadastro de cessões/disposições de servidores.",
        },
        {
          vmid: "og:title",
          property: "og:title",
          content: "Portal - Casa Civil do Estado de Goiás",
        },
        ...metaDados(this.$route),
      ],
    };
  },
  data() {
    return {
      autenticando: false,
      exibirModalEscolha: false,
      perfilAtual: null,
    };
  },
  async created() {
    await this.autenticar();
  },
  methods: {
    async autenticar() {
      try {
        this.autenticando = true;
        const dados = this.obterParametrosURL();

        if (dados.token && dados.iv) {
          await this.realizarAutenticacao(dados);
        } else {
          this.redirecionarPortal();
        }
      } catch (err) {
        console.error("❌ [Autenticar] Erro ao autenticar usuário:", err);
        this.redirecionarNaoEncontrado();
      } finally {
        this.autenticando = false;
      }
    },
    obterParametrosURL() {
      const urlParams = new URLSearchParams(window.location.search);
      return {
        token: urlParams.get("token"),
        iv: urlParams.get("iv"),
      };
    },
    async realizarAutenticacao(dados) {
      try {
        const { requerEscolha, perfilAtual } = await this.$auth.login(dados);
        console.log('[Autenticar.realizarAutenticacao] requerEscolha:', requerEscolha, '| perfilAtual:', perfilAtual);
        if (requerEscolha) {
          this.perfilAtual = perfilAtual;
          this.exibirModalEscolha = true;
        } else {
          this.irParaRotaInicial();
        }
      } catch (error) {
        console.error("❌ [realizarAutenticacao] Erro na autenticação:", error);
        this.redirecionarNaoEncontrado();
      }
    },
    aoEscolherPerfil(perfil) {
      console.log('[Autenticar.aoEscolherPerfil] perfil recebido:', perfil);
      this.exibirModalEscolha = false;
      this.$auth.aplicarPerfil(perfil);
      this.irParaRotaInicial();
    },
    // Home para quem tem home#index_show; senão Formulários
    // (formularios#index_show), seguindo a ordem de rotasPrivadas.
    irParaRotaInicial() {
      const rota = rotaInicial();
      console.log('[Autenticar.irParaRotaInicial] redirecionando para', rota ? rota.name : 'SemPermissao');
      this.$router.push({ name: rota ? rota.name : 'SemPermissao' });
    },
    redirecionarPortal() {
      const portalUrl = process.env.VUE_APP_PORTAL_URL;
      const redirectOriginal = this.$route.query.redirect || "/";
      const redirectUrl = encodeURIComponent(
        `${window.location.origin}${redirectOriginal}`
      );
      window.location.replace(
        `${portalUrl}/sessoes/autenticar?redirect=${redirectUrl}`
      );
    },
    redirecionarNaoEncontrado() {
      this.$router.push({ path: "/nao-encontrado" });
    },
    getRedirectPath() {
      if (this.$route.query.redirect) {
        try {
          const url = new URL(this.$route.query.redirect);
          return url.pathname;
        } catch (e) {
          console.log("URL de redirecionamento inválida:", e);
          return rotaInicial().path;
        }
      }
      return rotaInicial().path;
    },
  },
  computed: {
    $auth() {
      return new Auth();
    },
  },
};
</script>

<style lang="scss" scoped></style>
